module.exports = __webpack_public_path__ + "static/media/img3.b5d04b16.jpg";